import { render } from "./FormReasonsReportsComponent.vue?vue&type=template&id=107adae1&scoped=true"
import script from "./FormReasonsReportsComponent.vue?vue&type=script&lang=js"
export * from "./FormReasonsReportsComponent.vue?vue&type=script&lang=js"

import "./FormReasonsReportsComponent.vue?vue&type=style&index=0&id=107adae1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107adae1"]])

export default __exports__